import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { CONTACT_EMAIL } from '../data/site';
interface ContactBandProps {
  heading: string;
  body: string;
  eyebrow?: string;
}
export function ContactBand({
  heading,
  body,
  eyebrow
}: ContactBandProps) {
  return <section className="bg-ink-950" aria-labelledby="contact-band-heading" data-id="element-19" data-mp="1gxm53kort0a5">
      <div className="mx-auto max-w-6xl px-6 py-16 lg:px-10 lg:py-20" data-id="element-20" data-mp="129ra1xnaijtw">
        <div className="grid gap-8 lg:grid-cols-[1.2fr_1fr] lg:items-end" data-id="element-21" data-mp="127ekaybaj56a">
          <div data-id="element-22" data-mp="171si17dfdoe4">
            {eyebrow && <p className="mb-5 text-[11px] uppercase tracking-label text-accent-bright" data-id="element-23" data-mp="t8t6thkoegcd">
                {eyebrow}
              </p>}
            <h2 id="contact-band-heading" className="max-w-2xl font-display text-[32px] leading-[1.12] text-paper sm:text-[40px]" data-id="element-24" data-mp="y8p9ndhn01qc">
              {heading}
            </h2>
            <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-ink-300" data-id="element-25" data-mp="o8yd769incnm">{body}</p>
          </div>
          <div className="flex flex-col items-start gap-4 lg:items-end" data-id="element-26" data-mp="2t8d2cown0wg8">
            <Link to="/contact" className="group inline-flex items-center gap-2 bg-paper px-5 py-3 text-sm text-ink-950 transition-colors duration-150 ease-out hover:bg-accent hover:text-paper focus:outline-none focus-visible:ring-2 focus-visible:ring-paper focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950" data-id="element-27" data-mp="2oabfru006f00">
              Start a conversation
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-28" data-mp="25lwpxa1f970s" />
            </Link>
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-sm text-ink-300 underline decoration-ink-700 decoration-1 underline-offset-4 transition-colors duration-150 ease-out hover:text-paper hover:decoration-paper" data-id="element-29" data-mp="2jduvjavxcks7">
              {CONTACT_EMAIL}
            </a>
          </div>
        </div>
      </div>
    </section>;
}